import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(marketing)/track_shipment/[vulcanId]/search/page.tsx");
